import {createSlice} from '@reduxjs/toolkit'
import {InfoState} from '../../interfaces/_models'

const getBrowser = () => {
  const userAgentData = navigator.userAgentData?.toJSON().brands

  const info = userAgentData?.find(
    (element) =>
      !(
        element.brand.toLowerCase().indexOf('brand') !== -1 ||
        element.brand.toLowerCase().indexOf('chromium') !== -1
      )
  )

  if (info !== undefined) {
    //se podria cambiar por un (info)

    return [info?.brand.toString(), info?.version.toString()]
  }

  const userAgent = (() => {
    const ua = navigator.userAgent
    let tem
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || []
      return 'IE ' + (tem[1] || '')
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera')
    }
    M = M[2] ? [M[1], M[2]] : [navigator.userAgent, '-?']
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
    return M.join(' ')
  })().toString()

  return [userAgent.split(' ')[0], userAgent.split(' ')[1]]
}

const initialState: InfoState = {
  browserName: getBrowser()[0],
  browserVersion: getBrowser()[1],
  osIanaTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  appLanguage: navigator.language,
  osTimezone: -(new Date().getTimezoneOffset() / 60),
  appVersion: '1.1.0',
}

export const infoSlice = createSlice({
  name: 'info',
  initialState,
  reducers: {},
})

export default infoSlice.reducer
